import { useBoolean } from "ahooks";
import { Button, Input, Tag } from "antd";
import { ColumnsType } from "antd/lib/table";
import React, { useContext, useEffect, useState } from "react";
import { ButtonPanel } from "../../../../component/button-panel/button_panel";
import { Search } from "../../../../component/search";
import { DataTable } from "../../../../component/table";
import { DataTableStore } from "../../../../component/table/store/data_table_store";
import { Form } from "./cost_form";
import { ConfirmModal } from "../../../../component/modal";
import { Tips, TipsGroup } from "../../../../component/tips";
import { CostSearch } from "./cost_search";
import { CostFormStoreProvider } from "../../store/cost/cost_form_store";
import { CostStore } from "../../store/cost/cost_store";
import { costFormAction } from "../../action/cost/cost_form_action";
import { costAction } from "../../action/cost/cost_action";
import { Mask } from "../../../../component/mask";
import { defualtPageSize, Progress } from "../../../../logic/common_logic";
import { AuthLogic } from "../../../../logic/auth_logic";
import { Control, See, Edit, Del } from "../../../../component/control-column";

const formParams = {
  method: "Create",
  id: "",
  numberNo: "",
  subId: "",
  item: null,
};

export function Cost(viewPower) {
  const [createState, createFunc] = useBoolean(false);
  const [searchState, searchFunc] = useBoolean(false);
  const [confirmState, confirmFunc] = useBoolean(false);

  const { state, dispatch } = useContext(CostStore);
  const { state: tableState, dispatch: tableDispatch } =
    useContext(DataTableStore);

  const action = costAction,
    formGoodsAction = costFormAction;
  const [menuButton, setData] = useState([]);
  useEffect(() => {
    (async function () {
      let r = await new AuthLogic().selButton(viewPower.viewPower);
      if (r.length > 0) {
        for (let i = 0; i < r.length; i++) {
          r[i] = r[i].split("_")[r[i].split("_").length - 1];
        }
      }
      setData(r);
    })();

    return () => {};
  }, []);
  const columns: ColumnsType = [
    {
      title: "操作",
      key: "1",
      align: "center",
      width: Control.width(3),
      render: Control.render(
        (v, r) =>
          menuButton.indexOf("VIEW") != -1 && (
            <See
              click={() => {
                formParams.id = v.id;
                formParams.numberNo = r.numberNo;
                formParams.method = "Preview";

                createFunc.setTrue();
              }}
            />
          ),
        (v, r) =>
          r.status !== 1 &&
          menuButton.indexOf("UPDATE") != -1 && (
            <Edit
              click={() => {
                formParams.id = v.id;
                formParams.numberNo = r.numberNo;
                formParams.method = "Edit";
                formParams.item = r;

                createFunc.setTrue();
              }}
            />
          ),
        (v, r) =>
          r.status !== 1 &&
          menuButton.indexOf("DELETE") != -1 &&
          v.status !== 1 && (
            <Del
              click={() => {
                formParams.id = v.numberNo;
                formParams.subId = r.numberNo;

                confirmFunc.setTrue();
              }}
            />
          )
      ),
    },
    {
      title: "单据号",
      dataIndex: "numberNo",
      key: "2",
      align: "center",
      width: 180,
    },
    {
      title: "门店",
      dataIndex: "shopName",
      key: "3",
      align: "center",
    },
    {
      title: "订单状态",
      dataIndex: "status",
      key: "4",
      align: "center",
      render: (v) => (
        <>
          {v == "1" && <Tag color="success">已审核</Tag>}
          {v == "2" && <Tag color="error">未审核</Tag>}
          {v == "3" && <Tag>作废</Tag>}
        </>
      ),
    },
    {
      title: "理由",
      dataIndex: "reason",
      key: "6",
      align: "center",
      render: (v) => (v == 1 ? "日常变更" : "其他变更"),
    },
    {
      title: "制单人",
      dataIndex: "addUserName",
      key: "5",
      align: "center",
    },
    {
      title: "制单时间",
      dataIndex: "addDateTime",
      key: "7",
      align: "center",
      width: 130,
    },
    {
      title: "审核人",
      dataIndex: "checkUserName",
      key: "12",
      align: "center",
    },
    {
      title: "审核时间",
      dataIndex: "checkTime",
      key: "12",
      align: "center",
      width: 140,
    },
  ];

  const onSearch = async (pageIndex) => {
    await action.loadPage({
      pageIndex: pageIndex,
      pageSize: defualtPageSize(),
      dispatch: tableDispatch,
      search: state.search,
    });
  };

  return (
    <>
      <Search>
        <Input
          maxLength={50}
          placeholder="请输入单号"
          onChange={(e) =>
            action.setCondition({
              dispatch,
              key: "keywords",
              value: e.target.value,
            })
          }
        />
        <input type="button" value="快速查找" onClick={() => onSearch(1)} />

        <TipsGroup>
          <input
            type="button"
            value="高级查找"
            onClick={() => searchFunc.toggle()}
          />
          <Tips width="536px" display={searchState}>
            <CostSearch
              onSearch={(...arg: [any]) => {
                onSearch(...arg);
                searchFunc.setFalse();
              }}
            />
          </Tips>
          <Mask visible={searchState} onClick={() => searchFunc.setFalse()} />
        </TipsGroup>
      </Search>

      <ButtonPanel>
        {menuButton.indexOf("ADD") != -1 && (
          <Button
            onClick={() => {
              formParams.id = "";
              formParams.method = "Create";

              createFunc.setTrue();
            }}
          >
            新增成本变更
          </Button>
        )}
        {menuButton.indexOf("EXPORT") != -1 && (
          <Button
            onClick={async () => {
              await action.exportList({ search: state.search });
            }}
          >
            导出
          </Button>
        )}
      </ButtonPanel>

      <DataTable
        columns={columns}
        action={action}
        onLoad={async () => {
          await onSearch(1);
          Progress.done();
        }}
        onChange={(pageIndex) => {
          onSearch(pageIndex);
        }}
        scroll={{ scrollToFirstRowOnChange: true, autoY: true }}
        loading={tableState.loading}
      />

      {createState && (
        <CostFormStoreProvider>
          <Form
            audit={menuButton.indexOf("AUDIT") != -1 ? true : false}
            close={(hasUpdate) => {
              if (hasUpdate) {
                onSearch(tableState.current);
              }

              createFunc.setFalse();
            }}
            action={formGoodsAction}
            id={formParams.id}
            numberNo={formParams.numberNo}
            subId={formParams.subId}
            item={formParams.item}
            method={formParams.method}
          />
        </CostFormStoreProvider>
      )}

      <ConfirmModal
        visible={confirmState}
        title="温馨提示"
        subTitle="确认删除？"
        message="删除之后信息无法恢复，请慎重考虑"
        close={async (r) => {
          if (r) {
            await action.delRow(formParams.subId);

            onSearch(tableState.current);
          }
          confirmFunc.setFalse();
        }}
      />
    </>
  );
}
